export const theme = {
  overrides: {},
  props: {},
  shape: {},
  spacing: 8,
  typography: {
    fontFamily: ['poppins', 'Roboto', '-apple-system', 'sans-serif'].join(','),
  },
};
